module.exports = __webpack_public_path__ + "img/pauli-z-root-6.00348006.svg";